import { useId } from 'react';

import { Icon } from '@/shared/types/icon';

export const OpenAI = ({ size = 24, ...rest }: Icon) => {
  const id = useId();
  const maskId0 = `openai-mask-0-${id}`;
  const maskId1 = `openai-mask-1-${id}`;

  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      {...rest}
    >
      <mask
        id={maskId0}
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="32"
        height="32"
      >
        <path d="M31.9826 0.00444031H0.0269775V31.9601H31.9826V0.00444031Z" fill="white" />
      </mask>
      <g mask={`url(#${maskId0})`}>
        <mask
          id={maskId1}
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="5"
          y="5"
          width="22"
          height="22"
        >
          <path d="M26.7494 5.32408H5.26196V26.6197H26.7494V5.32408Z" fill="white" />
        </mask>
        <g mask={`url(#${maskId1})`}>
          <path
            d="M13.5034 13.0757V11.0526C13.5034 10.8822 13.5673 10.7544 13.7163 10.6693L17.7839 8.32676C18.3376 8.00733 18.9978 7.85834 19.6791 7.85834C22.2346 7.85834 23.8532 9.83888 23.8532 11.9471C23.8532 12.0961 23.8532 12.2665 23.8318 12.4369L19.6152 9.96652C19.3597 9.81753 19.1041 9.81753 18.8486 9.96652L13.5034 13.0757ZM23.0012 20.9551V16.1209C23.0012 15.8227 22.8734 15.6098 22.6179 15.4607L17.2727 12.3516L19.0189 11.3506C19.168 11.2655 19.2958 11.2655 19.4448 11.3506L23.5124 13.6931C24.6837 14.3747 25.4716 15.8227 25.4716 17.2281C25.4716 18.8465 24.5134 20.3373 23.0012 20.9549V20.9551ZM12.2469 16.696L10.5007 15.6739C10.3517 15.5888 10.2877 15.4609 10.2877 15.2906V10.6055C10.2877 8.32698 12.034 6.60191 14.3979 6.60191C15.2924 6.60191 16.1227 6.90011 16.8257 7.43249L12.6304 9.86027C12.375 10.0093 12.2471 10.2222 12.2471 10.5205V16.6962L12.2469 16.696ZM16.0057 18.8681L13.5034 17.4626V14.4814L16.0057 13.0759L18.5078 14.4814V17.4626L16.0057 18.8681ZM17.6135 25.3421C16.719 25.3421 15.8886 25.0439 15.1857 24.5116L19.3809 22.0837C19.6364 21.9347 19.7642 21.7218 19.7642 21.4235V15.2478L21.5319 16.2699C21.6808 16.355 21.7448 16.4828 21.7448 16.6533V21.3383C21.7448 23.6169 19.9772 25.3419 17.6135 25.3419V25.3421ZM12.5664 20.5932L8.49876 18.2507C7.3274 17.5691 6.53957 16.1211 6.53957 14.7157C6.53957 13.0759 7.51918 11.6065 9.03108 10.9889V15.8443C9.03108 16.1425 9.15895 16.3554 9.41442 16.5045L14.7384 19.5922L12.9922 20.5932C12.8432 20.6783 12.7153 20.6783 12.5664 20.5932ZM12.3322 24.0857C9.9258 24.0857 8.15821 22.2755 8.15821 20.0395C8.15821 19.8691 8.17955 19.6987 8.20073 19.5283L12.396 21.9561C12.6514 22.1051 12.9071 22.1051 13.1626 21.9561L18.5078 18.8683V20.8914C18.5078 21.0618 18.4439 21.1896 18.2948 21.2747L14.2273 23.6173C13.6736 23.9367 13.0134 24.0857 12.332 24.0857H12.3322ZM17.6135 26.6197C20.1903 26.6197 22.341 24.7884 22.831 22.3606C25.2161 21.743 26.7494 19.5069 26.7494 17.2283C26.7494 15.7376 26.1106 14.2896 24.9606 13.2461C25.0671 12.7988 25.131 12.3516 25.131 11.9045C25.131 8.8593 22.6606 6.58051 19.807 6.58051C19.2321 6.58051 18.6784 6.6656 18.1247 6.85737C17.1662 5.92032 15.8459 5.32408 14.3979 5.32408C11.8211 5.32408 9.67033 7.1554 9.18034 9.58319C6.79526 10.2008 5.26196 12.4369 5.26196 14.7154C5.26196 16.2062 5.90076 17.6542 7.05077 18.6977C6.94429 19.145 6.88038 19.5922 6.88038 20.0393C6.88038 23.0845 9.35073 25.3633 12.2044 25.3633C12.7793 25.3633 13.333 25.2782 13.8867 25.0864C14.8449 26.0235 16.1653 26.6197 17.6135 26.6197Z"
            fill="black"
          />
        </g>
      </g>
    </svg>
  );
};
